import { render } from "./Music.vue?vue&type=template&id=31c67528"
import script from "./Music.vue?vue&type=script&lang=js"
export * from "./Music.vue?vue&type=script&lang=js"

import exportComponent from "/Users/q/Documents/projects/religious-app/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__